import React from 'react'

import './style.scss'

function Footer() {

  return (
    <footer>
      <div className="medium">
        hi@inboom.com
      </div>
      <div className="medium">
        +52 55 40 12 88 69
      </div>
    </footer>
  )
}

export default Footer
